import React from 'react';
import { BiArch } from 'react-icons/bi';
import UserBox from '../user/UserBox';
import ControlBarPro from './ControlBarPro';
import AccountInfo from '../account/AccountInfo';
import TeamBox from '../team/TeamBox';
import './Header.css';

export default function Header() {  

  return (
    <div className='headerMain'>
      <div className='brandKiponos'>
        <div className='brandIcon'>
          <BiArch />
        </div>
        <div className='brandTitle'>
           Kiponos
        </div>
      </div>
      <ControlBarPro />
      <TeamBox />
      <AccountInfo />
      <UserBox />
    </div>
  )
}